import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { supabase } from '../lib/supabase';

export default function AuthConfirm() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('Verifying your email...');
  const navigate = useNavigate();

  useEffect(() => {
    const confirmEmail = async () => {
      try {
        const token_hash = searchParams.get('token_hash');
        const type = searchParams.get('type');

        if (!token_hash || !type) {
          setStatus('error');
          setMessage('Invalid confirmation link. Please request a new confirmation email.');
          return;
        }

        // Verify the email with Supabase
        const { data, error } = await supabase.auth.verifyOtp({
          token_hash,
          type: type === 'signup' ? 'signup' : 'email',
        });

        if (error) {
          console.error('Email confirmation error:', error);
          setStatus('error');
          setMessage(error.message || 'Failed to confirm email. The link may have expired.');
          return;
        }

        // Success! Email is confirmed
        setStatus('success');
        setMessage('Email confirmed successfully! Redirecting to login...');

        // Wait 2 seconds then redirect to login
        setTimeout(() => {
          navigate('/login', {
            state: {
              message: 'Email confirmed! Please sign in with your credentials.'
            }
          });
        }, 2000);

      } catch (err) {
        console.error('Unexpected error during confirmation:', err);
        setStatus('error');
        setMessage('An unexpected error occurred. Please try again or contact support.');
      }
    };

    confirmEmail();
  }, [searchParams, navigate]);

  return (
    <div className="container" style={{ paddingTop: '60px' }}>
      <div className="card" style={{ maxWidth: '600px', margin: '0 auto', textAlign: 'center' }}>
        {/* Status Icon */}
        <div style={{ fontSize: '64px', marginBottom: '20px' }}>
          {status === 'verifying' && '⏳'}
          {status === 'success' && '✅'}
          {status === 'error' && '❌'}
        </div>

        {/* Heading */}
        <h2 style={{
          fontSize: '28px',
          marginBottom: '15px',
          color: status === 'error' ? '#e74c3c' : '#2c3e50'
        }}>
          {status === 'verifying' && 'Confirming Your Email'}
          {status === 'success' && 'Email Confirmed!'}
          {status === 'error' && 'Confirmation Failed'}
        </h2>

        {/* Message */}
        <p style={{
          fontSize: '16px',
          color: '#7f8c8d',
          marginBottom: '25px',
          lineHeight: '1.6'
        }}>
          {message}
        </p>

        {/* Loading spinner for verifying state */}
        {status === 'verifying' && (
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '30px'
          }}>
            <div className="spinner"></div>
          </div>
        )}

        {/* Error state - show actions */}
        {status === 'error' && (
          <div style={{ marginTop: '30px' }}>
            <button
              onClick={() => navigate('/confirm-email')}
              className="btn btn-secondary"
              style={{ width: '100%', marginBottom: '10px' }}
            >
              Resend Confirmation Email
            </button>
            <button
              onClick={() => navigate('/login')}
              className="btn btn-primary"
              style={{ width: '100%' }}
            >
              Go to Login
            </button>
          </div>
        )}

        {/* Success state - show manual redirect option */}
        {status === 'success' && (
          <div style={{ marginTop: '30px' }}>
            <button
              onClick={() => navigate('/login')}
              className="btn btn-primary"
              style={{ width: '100%' }}
            >
              Continue to Login →
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
